import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=fa3845de&scoped=true&"
import script from "./modal.vue?vue&type=script&lang=ts&"
export * from "./modal.vue?vue&type=script&lang=ts&"
import style0 from "./modal.vue?vue&type=style&index=0&id=fa3845de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3845de",
  null
  
)

export default component.exports